import { createIcon } from '@chakra-ui/icons'

// using `path`
export const AdaptabilityIcon = createIcon({
  displayName: 'AdaptabilityIcon',
  viewBox:"0, 0, 700,700",

  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (<g transform="translate(0.000000,700.000000) scale(0.100000,-0.100000)"
  fill="black" stroke="none">
  <path d="M4161 6758 c-28 -91 -233 -870 -229 -874 3 -2 31 -7 64 -10 53 -5 65
  -3 118 25 47 25 70 31 120 31 228 0 352 -267 202 -437 -124 -141 -327 -121
  -432 42 -28 45 -42 57 -86 73 -29 11 -56 17 -59 14 -8 -10 -243 -892 -238
  -896 2 -2 202 -57 444 -121 242 -64 443 -120 447 -124 3 -3 -3 -30 -14 -59
  -16 -44 -28 -58 -73 -87 -97 -62 -142 -149 -132 -256 15 -170 180 -277 351
  -227 55 16 148 109 164 164 22 74 15 144 -19 213 -28 55 -30 68 -24 117 4 30
  12 57 18 59 7 3 210 -49 452 -114 298 -80 442 -115 446 -107 12 20 552 2046
  547 2051 -2 3 -459 127 -1014 275 -555 149 -1016 273 -1026 276 -12 3 -19 -4
  -27 -28z"/>
  <path d="M770 4835 l0 -1055 451 0 451 0 -7 43 c-5 27 -19 55 -41 79 -61 68
  -79 114 -79 203 0 64 5 89 24 125 32 61 76 107 136 138 68 36 188 38 252 4
  101 -53 161 -139 170 -242 7 -76 -17 -147 -73 -216 -29 -35 -46 -67 -50 -94
  l-7 -40 452 0 451 0 0 451 0 452 66 -6 c59 -6 70 -10 101 -42 57 -59 107 -80
  193 -80 85 0 134 20 190 77 77 77 97 207 47 304 -48 94 -130 144 -237 144 -77
  0 -129 -21 -189 -75 -40 -36 -87 -54 -143 -55 l-28 0 0 470 0 470 -1065 0
  -1065 0 0 -1055z"/>
  <path d="M1760 4361 c-194 -63 -254 -298 -114 -442 35 -36 53 -85 54 -141 l0
  -28 -465 0 -465 0 0 -1070 0 -1070 1055 0 1055 0 0 451 0 452 -51 -5 c-35 -4
  -57 -12 -68 -25 -56 -69 -176 -112 -262 -94 -101 22 -177 80 -220 169 -34 70
  -32 179 3 247 57 108 147 165 263 165 84 0 138 -22 201 -80 37 -34 50 -40 89
  -40 l45 0 -2 448 -3 447 -452 3 -453 2 0 33 c0 54 18 102 51 133 55 52 74 99
  74 189 0 88 -14 125 -69 183 -47 50 -101 75 -176 78 -36 2 -76 0 -90 -5z"/>
  <path d="M2900 3280 c0 -258 -3 -470 -7 -470 -5 0 -34 4 -66 10 -45 7 -63 15
  -83 39 -59 71 -193 104 -288 72 -49 -17 -121 -83 -148 -134 -61 -120 -13 -279
  104 -346 107 -61 224 -49 316 34 29 26 63 47 81 50 17 3 45 7 61 10 l30 5 0
  -470 0 -470 1070 0 1070 0 0 1070 0 1070 -466 0 -467 0 5 -65 c5 -57 9 -68 40
  -97 59 -56 83 -112 83 -198 0 -89 -21 -136 -85 -194 -56 -50 -102 -68 -175
  -69 -151 -1 -265 112 -265 262 0 78 25 139 77 193 34 35 51 83 53 146 l0 22
  -470 0 -470 0 0 -470z"/>
 
 
  
  </g>
    
  ),
})
